export default angular.module('eventix.common.services.summaryLoader', [])
    .factory('SummaryLoader', function($http, $q, $location, Order, UIMessages, User, $rootScope) {
        var SummaryLoader = {};
        var cache = {
            company: false,
            insightCompany: false,
            shop: false,
            event: false
        };

        $rootScope.$on('clearCache', () => {
            SummaryLoader.clearCache();
        });

        SummaryLoader.clearCache = function() {
            _.keys(cache).forEach(k => cache[k] = false);
        };

        SummaryLoader.getTicketsalesamount = function(start, end, period) {
            if (!period)
                period = 'days';
            if (!start || !end) {
                start = moment().subtract(7 - 1, period);
                end = moment();
            }

            return $http.get(`/admin/dashboard/sales/${period}/${start.format('YYYY-MM-DD')}/${end.format('YYYY-MM-DD')}/`).then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getTicketsalesamountgrowth = function(start, end, period) {
            if (!period)
                period = 'days';
            if (!start || !end) {
                start = moment().subtract(7 - 1, period);
                end = moment();
            }

            return $http.get(`/admin/dashboard/sales/growth/${period}/${start.format('YYYY-MM-DD')}/${end.format('YYYY-MM-DD')}/`).then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getProfitwhitelabelgrowth = function(start, end, period, company) {
            if (!period)
                period = 'days';
            if (!start || !end) {
                start = moment().subtract(7 - 1, period);
                end = moment();
            }

            if (!company)
                company = '2e7431d0-3668-11e6-9cba-f109056d8749';

            return $http.get(`/admin/dashboard/profit/company/${company}/${period}/${start.format('YYYY-MM-DD')}/${end.format('YYYY-MM-DD')}/`).then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getRevenuegrowth = function(start, end, period) {
            if (!period)
                period = 'days';
            if (!start || !end) {
                start = moment().subtract(7 - 1, period);
                end = moment();
            }

            return $http.get(`/admin/dashboard/revenue/${period}/${start.format('YYYY-MM-DD')}/${end.format('YYYY-MM-DD')}/`).then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getUpcomingevents = function(start, end, period) {
            if (!period)
                period = 'days';
            if (!start || !end) {
                start = moment();
                end = moment().add(7 - 1, period);
            }

            return $http.get(`/admin/dashboard/events/upcoming/${period}/${start.format('YYYY-MM-DD')}/${end.format('YYYY-MM-DD')}/`).then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getCurrentevents = function(start, end, period) {
            if (!period)
                period = 'days';
            if (!start || !end) {
                start = moment().subtract(7 - 1, period);
                end = moment();
            }

            return $http.get(`/admin/dashboard/events/current/${period}/${start.format('YYYY-MM-DD')}/${end.format('YYYY-MM-DD')}/`).then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getNeworganisationsandevents = function(amount) {
            if (!amount)
                amount = 10;

            return $http.get(`/admin/dashboard/new/${amount}/`).then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getTotaltickets = function() {
            return $http.get('/admin/dashboard/total/tickets/').then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        SummaryLoader.getTotalrevenue = function() {
            return $http.get('/admin/dashboard/total/revenue/').then(response => {
                return response.data;
            }, error => {
                UIMessages.push('common.notice.error');
                return error;
            });
        };

        return SummaryLoader;
    }).name;
